module.exports = __webpack_public_path__ + "media/heart2heart-poster.48115ecc.mp4";